import React from 'react';
import Navbar from '../../components/navbar';
import FooterAppp from '../../components/footerApp';
import ContactComponent from './ContactComponent';
const Contact = () => {
  return (
    <React.Fragment>
      <Navbar isBlack={true} />
      <ContactComponent />
      <FooterAppp />
    </React.Fragment>
  );
};

export default Contact;
